import React, { Component } from "react";
import {Link} from 'react-router-dom';
import AuthLayout from "./authLayout.js"
import SimpleReactValidator from 'simple-react-validator';
import service from '../services'
import Loader from "../component/loader.js";
let sub;
class ForgetPassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: "",
            loaderFlag: false,
            alertMsg:''

        };
        this.validator = new SimpleReactValidator({ autoForceUpdate: this });
        this.apiserve = new service();

    }

    componentDidMount = () => {
        sub = this.apiserve.getevent().subscribe((response) => {
           switch (response.event) {
                case "forgotPasswordUser":
                    if(response.error){
                        this.setState({ loaderFlag: false,alertMsg: response.data.error ? response.data.error : response.data.msg})
                        // this.apiserve.error(response.data.error ? response.data.error : response.data.msg)
                    }else{
                        this.setState({ loaderFlag: false })
                        this.apiserve.success(response.data.error ? response.data.error : response.data.msg)
                        this.props.history.push('/')
                    }   
            }
        })
    }

    componentWillUnmount = () => {
        sub.unsubscribe();
      }

    onInputChange = (e) => {
        this.setState({
            alertMsg:"",
            [e.target.name]: e.target.value,
        });
    }

    forgotPasswordUser = () => {
        this.apiserve.sendevent("forgotPasswordUser", { 
            email: this.state.email,
            platform: "cms"
        });
    }
    submitFn = (e) => {
        e.preventDefault();
        if (this.validator.allValid()) {
            this.setState({
                loaderFlag: true,
              });
              this.forgotPasswordUser()
            // let data = {
            //     value: {
            //       email: this.state.email
            //     },
            //     api: "/forgot",
            //   };
            //   this.apiserve
            //     .postApi(data)
            //     .then((res) => {  
            //         setTimeout(()=>{
            //             this.setState({loaderFlag:false})
            //             this.apiserve.success(res.data.msg)   
            //             this.props.history.push('/')
            //         },1000)                 
            //     })
            //     .catch((error) => {
            //       if (error.response) {
            //         setTimeout(() => {
            //             this.setState({
            //                 loaderFlag: false
            //               },() => this.apiserve.error(error.response.data.errors.msg));
            //           }, 3000); 
            //       }
            //     });
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }

    clearFn = () => {
        this.setState({
            email: "",
            alertMsg:""
        });
    };
    render() {
        return (
            <AuthLayout>
                {/* Box Design Start here */}
                <div className="box_wrapper forgot_box_Wrapper">
                    <h2>Reset Password</h2>
                    <div>
                        Please provide the email that you  have used to register. We will send you a link to reset your password.
                        <span>You may also check your SPAM folder</span>
                    </div>
                    <form onSubmit={() => this.submitFn()}>
                        <div>
                            <label>Email</label>
                            <input
                                type="email"
                                name="email"
                                id="email"
                                maxLength={255}
                                value={this.state.email}
                                onChange={this.onInputChange}
                            />
                            {
                                this.state.alertMsg ?<span style={{color : 'red'}} className="reset_error">{this.state.alertMsg}</span>:
                                <span style={{ color: 'red' }}>{this.validator.message('Email', this.state.email, 'required|email')}</span>
                            }
                           
                            
                        </div>
                       
                        <div>
                            <button 
                                className="grayBTN"
                                type="button"
                                onClick={() => this.clearFn()}
                                >Clear</button>
                            <button
                                className="orangeBTN"
                                type="submit"
                                onClick={(e) => this.submitFn(e)}
                            >Submit</button>
                        </div>
                        <div>
                            <p className=" text_center">Go back to <Link className="link" to="/">Sign in</Link> </p>
                        </div>
                    </form>
                </div>
                {/* Box Design End's here */}

                {/* Loader */}
                {this.state.loaderFlag ? (
                    <Loader/>
                    ) : (
                    ""
                )}
            </AuthLayout>
        )
    }
}
export default ForgetPassword;